<template>
    <rkm-tabs
        :tab-refs="tabRefs"
        v-model="tabIndex"
    >
        <rkm-tab
            active
            title="BNAFAR"
        >
            <Bnafar
                :data="data.bnafar"
                ref="Bnafar"
            />
        </rkm-tab>

        <rkm-tab
            title="Dispensação"
        >
            <Dispensacao
                :data="data"
                ref="Dispensacao"
            />
        </rkm-tab>
    </rkm-tabs>
</template>

<script>
// Components.
import Bnafar from './components/bnafar/Form'
import Dispensacao from './components/dispensacao/Form'

export default {
    components: { Bnafar, Dispensacao },
    data: () => ({
        tabIndex: 0,
        tabRefs: [],
    }),
    methods: {
        async validate() {

            const currentValid = await this.tabRefs[this.tabIndex].validate()

            if (!currentValid) {

                return false;
            }

            let valid = true

            for (let i = 0; i < this.tabRefs.length; i++) {

                if (i !== this.tabIndex) {

                    valid = await this.tabRefs[i].validate()

                    if (!valid) {

                        this.tabIndex = i

                        break
                    }
                }
            }

            return valid
        },
    },
    mounted() {

        this.tabRefs = [
            this.$refs.Bnafar,
            this.$refs.Dispensacao,
        ]
    },
    props: {
        data: { type: Object, required: true },
    }
}
</script>